import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import PDPAnalyticsActionFilter from 'yoda-site-components/lib/analytics/PDPAnalyticsActionFilter';
import {
    MINI_PDP_PAGE_LOAD_READY,
    MINI_PDP_CART_ADD_ANALYTICS,
    MINI_PDP_PRODUCT_OOS_ANALYTICS,
    MINI_PDP_UPDATE_ITEM_SUCCESS,
    MINI_PDP_CARE_PLAN_ACCEPT_ANALYTICS,
    MINI_PDP_CARE_PLAN_VIEW_ANALYTICS,
    MINI_PDP_OPEN_MODAL_ANALYTICS,
    MINI_PDP_PAGE_LOAD_PRODUCT_OOS,
} from '../actionTypes/MiniPDPAnalyticsActionTypes';

const miniPDPAnalyticsActionFilter = new PDPAnalyticsActionFilter();

/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AnalyticsMiddleware = store => next => action => { // eslint-disable-line
    /* istanbul ignore else */
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        let digitalDataInventory = null;
        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                /* istanbul ignore next */
                case MINI_PDP_PAGE_LOAD_READY: {
                    digitalData = miniPDPAnalyticsActionFilter.getPdpPageDL(store, action.payload);
                    digitalData = miniPDPAnalyticsActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    break;
                }
                /* istanbul ignore next */
                case MINI_PDP_PAGE_LOAD_PRODUCT_OOS: {
                    digitalDataInventory = miniPDPAnalyticsActionFilter.getPdpPageDLProductOOS(
                        store,
                        action.payload
                    );
                    analyticsEventName = 'inventoryProductOOS';
                    break;
                }
                case MINI_PDP_CART_ADD_ANALYTICS: {
                    digitalData = miniPDPAnalyticsActionFilter.getCartAddData(
                        store,
                        action.payload
                    );
                    analyticsEventName = 'cartAdd';
                    break;
                }
                case MINI_PDP_PRODUCT_OOS_ANALYTICS: {
                    digitalData = miniPDPAnalyticsActionFilter.getProductOOSData(store, {
                        sourceMiniPDP: true,
                    });
                    analyticsEventName = 'productOOS';
                    break;
                }

                case MINI_PDP_UPDATE_ITEM_SUCCESS: {
                    analyticsEventName = 'updateItemListSlider';
                    break;
                }

                case MINI_PDP_CARE_PLAN_ACCEPT_ANALYTICS: {
                    digitalData = miniPDPAnalyticsActionFilter.getCarePlanAcceptData(
                        action.payload
                    );
                    analyticsEventName = 'carePlanAccept';
                    break;
                }

                case MINI_PDP_CARE_PLAN_VIEW_ANALYTICS: {
                    digitalData = miniPDPAnalyticsActionFilter.getCarePlanViewData(action.payload);
                    analyticsEventName = 'carePlanView';
                    break;
                }

                case MINI_PDP_OPEN_MODAL_ANALYTICS: {
                    digitalData = miniPDPAnalyticsActionFilter.getModalOpenData(action.payload);
                    analyticsEventName = 'openModal';
                    break;
                }

                default:
                    break;
            }
            /* istanbul ignore next */
            if (analyticsEventName || digitalData || digitalDataInventory) {
                if (analyticsEventName === 'inventoryProductOOS') {
                    analytics.track(analyticsEventName, digitalDataInventory);
                } else {
                    analytics.track(analyticsEventName, digitalData);
                }
            }
        } catch (error) {
            // @TODO - this should be added into LOGGER
        }
    }

    return next(action);
};

export default AnalyticsMiddleware;
